import { inject, Injectable } from '@angular/core';
import { APP_ENVIRONMENT, AppEnvironment } from '../tokens/environment.token';

@Injectable({providedIn: 'root'})
export class BaseService {

  private env: AppEnvironment = inject(APP_ENVIRONMENT);

  get apiUrl() { return this.env.apiUrl; }
  get projects() { return this.env.projectsApi; }
  get projectRoles() { return this.env.projectroles; }
  get models() { return this.env.modelsApi; }
  get revisions() { return this.env.revisionsApi; }
  get wexbim() { return this.env.revisionsApi; }
  get apiUrlRevisions() { return this.env.apiUrlRevisions; }
  get account() { return this.env.account; }
  get identity() { return this.env.identityApi; }
  get identityAccount() { return this.env.identityAccount; }
  get identityAdmin() { return this.env.identityAdmin; }
  get userprofiles() { return this.env.userProfile; }
  get userPermissions() { return this.env.userPermissions; }
  get permissions() { return this.env.permissions; }
  get genericDocuments() { return this.env.genericDocuments; }
  get documents() { return this.env.documents; }
  get valueConfPage() { return this.env.valueConfPage; }
  get valueConfAttribute() { return this.env.valueConfAttribute; }
  get attributeValue() { return this.env.attributeValue; }
  get statusColor() { return this.env.statusColor; }
  get databaseMigrations() { return this.env.databaseMigrations; }
  get groupRoles() { return this.env.groupRoles; }
  get platformGroupRoles() { return this.env.platformGroupRoles; }
  get projectGroupRoles() { return this.env.projectGroupRoles; }
  get groupRolePermissions() { return this.env.groupRolePermissions; }
  get projectGroupRolePermissions() { return this.env.projectGroupRolePermissions; }
  get localLegacySquirrelCommonApi() { return this.env.localLegacySquirrelCommonApi; }
  get localLegacySquirrelV3() { return this.env.localLegacySquirrelV3; }
  get devLegacySquirrelCommonApi() { return this.env.devLegacySquirrelCommonApi; }
  get devLegacySquirrelV3() { return this.env.devLegacySquirrelV3; }
  get squirreltest1LegacySquirrelCommonApi() { return this.env.squirreltest1LegacySquirrelCommonApi; }
  get squirreltest1LegacySquirrelV3() { return this.env.squirreltest1LegacySquirrelV3; }
  get sq3devLegacySquirrelCommonApi() { return this.env.sq3devLegacySquirrelCommonApi; }
  get sq3devLegacySquirrelV3() { return this.env.sq3devLegacySquirrelV3; }
  get tenants() { return this.env.tenants; }
  get tenantProjects() { return this.env.tenantProjects; }
  get tenantUsers() { return this.env.tenantUsers; }
  get tenantProjectGroupRoles() { return this.env.tenantProjectGroupRoles; }
  get tenantGroupRolePermissions() { return this.env.tenantGroupRolePermissions; }
  get tenantProjectRoles() { return this.env.tenantProjectRoles; }
  get tenantProjectGroupRolePermissions() { return this.env.tenantProjectGroupRolePermissions; }
  get tenantplatformGroupRoles() { return this.env.tenantplatformGroupRoles; }
  get tenantpermissions() { return this.env.tenantpermissions; }
  get tenantgrouproles() { return this.env.tenantgrouproles; }
  get tenantapplicationtokens() { return this.env.tenantapplicationtokens; }
  get tenantAudit() { return this.env.tenantaudit; }
  get tenantfiles() { return this.env.tenantfiles; }
  get projecturl() { return this.env.projecturl; }

  constructor() { }
}
